// extracted by mini-css-extract-plugin
module.exports = {"teaser":"Category_teaser__OQP86","wrap":"Category_wrap__2xL3Y","contentWrap":"Category_contentWrap__1ONc4","title":"Category_title__SYcs2"};